/* eslint-disable react/require-default-props */
import React, { FC, Suspense } from 'react';
import { ErrorBoundary } from 'react-error-boundary';
import { ChatNotificationButtonProps } from './types';

const ChatFretebrasButton = React.lazy(() => import('chatFretebras/ChatButton'));

const ChatNotificationButton: FC<ChatNotificationButtonProps> = ({ ...props }) => {
  const fallbackRender = (): JSX.Element => null;

  return (
    <ErrorBoundary onReset={() => null} fallbackRender={fallbackRender} data-testid="error-boundary">
      <Suspense fallback={null}>
        <ChatFretebrasButton {...props} />
      </Suspense>
    </ErrorBoundary>
  );
};

export default ChatNotificationButton;
